import React from 'react';

import { addLinkTestId } from '../../helpers/addTestId';
import uniqueId from '../../helpers/uniqueId';
import { Link as ContentfulLink } from './types/Navigation.types';
import { LinkWithIcon } from '@legacy-vfuk/core-link-with-icon';
import { MainLinksWrapper, BrandLogo } from './styles/MainLinks.styles';
import { ReactComponent as VodafoneNoMargin } from '../../images/icon/vodafone-nomargin.svg';
import {
  runNavigationEventData,
} from '../../helpers/navigationHelpers';
import NavigationItem from './NavigationItem';

type MainLinksProps = {
  brandLink: string;
  mainLinks: ContentfulLink[];
  pageTitle: string;
  signInLabel: string | undefined;
  signInUrl: string | undefined;
  secondLanguageUrlPrefix: string | undefined;
  isSecondLanguageOnUrl: boolean | undefined;
};

const MainLinks: React.FC<MainLinksProps> = ({
  brandLink,
  mainLinks,
  pageTitle,
  signInLabel,
  signInUrl,
  isSecondLanguageOnUrl,
  secondLanguageUrlPrefix,
}) => {
  return (
    <MainLinksWrapper id="sticky-top-header">
      <div>
        <BrandLogo
          id="logo"
          href={brandLink}
          aria-label="Vodafone-logo"
          title={'vodafone-icon'}
          data-analytics-element={uniqueId('vodafone-icon')}
          data-analytics-context={pageTitle}
          data-analytics-category={'Link'}
          data-testid={'vodafone-icon'}
          onClick={async () => {
            await runNavigationEventData({ location: 'header' });
          }}
        >
          <VodafoneNoMargin />
        </BrandLogo>

        <nav>
          <ul className="main-nav-items">
            {mainLinks.map(mainLink => (
              <li key={mainLink.contentful_id}>
                <NavigationItem
                  allLinks={mainLinks}
                  link={mainLink}
                  pageTitle={pageTitle}
                  secondLanguageUrlPrefix={secondLanguageUrlPrefix}
                  isSecondLanguageOnUrl={isSecondLanguageOnUrl}
                />
              </li>
            ))}
          </ul>
          {signInLabel && signInUrl && (
            <ul className="sign-in-items">
              <li>
                <LinkWithIcon
                  href={signInUrl}
                  icon={{
                    name: 'admin',
                    justify: 'left',
                  }}
                  srText={signInLabel}
                  text={signInLabel}
                  appearance="secondary"
                  size={3}
                  dataAttributes={{
                    title: signInLabel,
                    'data-analytics-element': uniqueId(signInLabel),
                    'data-analytics-context': pageTitle,
                    'data-analytics-category': 'Link',
                    'data-testid': addLinkTestId('mainLink', signInLabel),
                  }}
                  onClick={async () => {
                    await runNavigationEventData({ location: 'header' });
                  }}
                />
              </li>
            </ul>
          )}
        </nav>
      </div>
    </MainLinksWrapper>
  );
};

export default MainLinks;
